// removed by extract-text-webpack-plugin
module.exports = {"serviceDetail":"_2Y2nP-wsTR5_UsVlKIv0dT","head":"_2ba2qCLMLx_onCdiUy6M5Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/ServiceList.scss
// module id = 1133
// module chunks = 0